import { createAction } from "@ngrx/store";
import { IUser } from "../../models/user/user.model";

export const setCurrentUser = createAction(
  '[User] Set Current User',
  (user: IUser) => ({user})
);


